function isEmpty(value){
  return (value == null || value.length === 0 || value == undefined);
}


const validate = values => {
  const errors = {}
  const requiredFields = [];

  requiredFields.forEach(function(field){
    if(isEmpty(values[field])){
      errors[field] = 'Required';
    }
  });

  return errors
}

export default validate
